export enum NumberAbbreviationEnum {
  'K' = 'K',
  'M' = 'M',
  'B' = 'B',
  'T' = 'T',
  'U' = 'U',
}
